import { render, staticRenderFns } from "./StockPriceDate.vue?vue&type=template&id=b1805640&scoped=true&"
import script from "./StockPriceDate.vue?vue&type=script&lang=js&"
export * from "./StockPriceDate.vue?vue&type=script&lang=js&"
import style0 from "./StockPriceDate.vue?vue&type=style&index=0&id=b1805640&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1805640",
  null
  
)

export default component.exports